module.exports = __webpack_public_path__ + "static/media/015-full battery.e83b4600.svg";